<template lang="pug">
div.container-fluid.animated.fadeIn
  nav(aria-label="breadcrumb")
    b-breadcrumb
      b-breadcrumb-item
        router-link(to="/report/bankstatementdaily")
          i.fa.fa-poll-h
          span.ml-1 {{ $t("ui.bank_statement_daily") }}
  div.row
    div.col-md-12
      div.card
        div.card-header
          div.row
            div.col-md-12.mb-1
              div.row
                div.col-md-2.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      i.fa.fa-calendar
                    date-picker(v-model="workingDate" :config="locale")
                div.col-md-4.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      span {{ $tc("ui.banks", 1) }}
                    BankAccountList(
                      ref="bank"
                      size="sm"
                      required
                      type="array"
                      v-model="bank"
                      :disabled="loading"
                      filterBankAccStatus=false
                    )
                div.col-md-2.mb-1
                  SubmitButton(
                    :loading="loading"
                    icon="fa fa-search"
                    :text="$t('ui.search')"
                    type="button"
                    @click="getBankStatementDaily()"
                    variant="success"
                    size="sm"
                    )
        div.card-body
          div.row.clusterize
            div.col-md-12
              .clusterize-scroll
                table.tablex(style="width: auto;min-width: 30%;")
                  thead
                    tr
                      th.sticky-position(width="10%")
                        span #
                      th.sticky-position(width="40%")
                        span(:title="$t('ui.transfer_type')") {{ $t('ui.transfer_type') }}
                      th.sticky-position(width="50%")
                        span(:title="$t('ui.transfer_amount')") {{ $t('ui.transfer_amount') }}
                  tbody.clusterize-content
                    tr(v-if="reportList.length == 0")
                      td(:colspan="3").text-center
                        span {{ $t('message.no_data_available') }}
                    tr(v-for="(item, index) in reportList")
                      td
                        span {{ index + 1 }}
                      td
                        span(:title="item.transfer_type") {{ getTransferType(item.transfer_type) }}
                      td
                        span(:title="$n(item.transfer_amount, 'currency')" :class="[item.transfer_amount > 0 && item.transfer_type.trim().toUpperCase() == 'WITHDRAWAL' ? 'text-danger' : 0]") {{ $n(item.transfer_amount, 'currency') }}
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import BankAccountList from "@/library/BankAccountList";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    BankAccountList
  },
  data: () => ({
    loading: false,
    reportList: [],
    search: "",
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    locale: {
      format: "YYYY-MM-DD",
      useCurrent: true
    },
    startDate: null,
    endDate: null,
    bank: '',
    currentBank: null,
    workingDate: null,
    sortKey: "transfer_date",
    sortType: "desc"
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    on() {
      return this.$t("ui.on");
    },
    off() {
      return this.$t("ui.off");
    }
  },
  mounted: function() {
    this.workingDate = this.$moment(new Date).format('YYYY-MM-DD');
  },
  methods: {
    getTransferType(type) {
      if (type.toUpperCase() == "DEPOSIT")
        return "CREDIT";
      else if (type.toUpperCase() == "WITHDRAWAL")
        return "DEBIT";

      return "";
    },
    getBankStatementDaily: function(isSearch) {
      this.currentBank = this.bank;

      let url = config.bankStatementDailyUrl();

      if (isSearch) this.currentPage = 1;

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        bank_id: this.bank == '' ? null : this.bank.split(' - ')[0].trim(),
        bank_acc_no: this.bank == '' ? null : this.bank.split(' - ')[1].trim(),
        working_date: this.workingDate
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.reportList = response.data.dt;
              } else {
                if (this.feedback.status != 'permission_denied') {
                  if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                }
                else {
                  this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                }
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>
<style lang="scss" scoped>
.text-italic {
  font-style: italic !important;
}
</style>